<script>
import jwt_decode from 'jwt-decode'
import tokenRefreshManager from '../plugins/TokenRefreshUtil'

export default {
	data() { return {
		now: 0,
		nowTimer: null,
	}},
	computed: {
		tokenDecoded() {
			const loggedInUser = this.$store.state.loggedInUser
			if (!loggedInUser?.kc_token) return
			return jwt_decode(loggedInUser.kc_token)
		},
		refreshTokenDecoded() {
			const loggedInUser = this.$store.state.loggedInUser
			if (!loggedInUser?.kc_refresh_token) return
			try {
				return jwt_decode(loggedInUser.kc_refresh_token)
			}
			catch (e) {
				return null
			}
		},
		tokenExpiresInSeconds() {
			const ts = this.tokenDecoded?.exp
			return Math.floor(Math.max(0, (Number(ts + '000') - this.now) / 1000))
		},
		refreshTokenExpiresInSeconds() {
			const ts = this.refreshTokenDecoded?.exp
			return Math.floor(Math.max(0, (Number(ts + '000') - this.now) / 1000))
		},
		tokenHasExpired() {
			// Check if refresh token has expired
			if (this.refreshTokenExpiresInSeconds <= 0) {
				this.errorTitle = this.$t('text.ERROR')
				this.errorDetail = this.$t('text.logoutDueToExpiredToken')
				return true
			}
			
			// If access token expired but refresh token is still valid, don't show error
			// (automatic refresh will handle it)
			return false
		},
	},
	mounted() {
		this.nowTimer = setInterval(() => {
			this.now = Date.now()
		}, 1000)
	},
	beforeUnmount() {
		clearInterval(this.nowTimer)
	},
}
</script>